import { useQuery } from 'react-query';
import { getMerchantData } from '../justifi.api';

export const useGetJustifiMerchantData = ({ locationId }: { locationId: string }) => {
  const { data, isLoading } = useQuery({
    queryKey: [locationId, 'justifi', 'merchant'],
    queryFn: async () => getMerchantData({ locationId }),
    retry: false,
    refetchOnWindowFocus: false,
    enabled: !!locationId,
  });

  return { ...data, loading: isLoading };
};
